module.exports = __webpack_public_path__ + "assets/img/ca6a598ab34ff3b213f2ab39b640e958.svg";